import React from 'react';
import { useLocation } from 'react-router-dom';

import ReportGenerator from '../../common/ReportGenerator/ReportGenerator.module';

const DPEReport: React.FC = () => {
  const location = useLocation(); // Initialize useLocation
  const { selectedCoproId } = location.state || {}; // Extract coproId from state
  const getReportUrl = (companyId: string, coproId: string) => `/api/companies/${companyId}/copros/${coproId}/report/dpes/generate`;

  return (
    <ReportGenerator
      description="Cette page vous permet de générer des rapports des DPEs pour vos copropriétés. Ces rapports incluent tous les DPEs de la copropriété sélectionnée et des informations sur la copropriété."
      getReportUrl={getReportUrl}
      generatedPdfFileName="rapport_dpe"
      initialCoproId={selectedCoproId || null}
    />
  );
};

export default DPEReport;
